/* eslint-disable @typescript-eslint/no-explicit-any */
import to from "await-to-js";
import * as T from "../api.interface";
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";
const colorAxiosInstance = newColorAxiosInstance;

// 密码重置
export const retrievePasswordApi = async (requestData: any): Promise<T.RequestTo<any>> => {
  return await to(
    colorAxiosInstance
      .post<T.RequestTo<any>>("user_account_resetPassword", undefined, { params: requestData })
      .then((response: any) => response.data)
      .catch((err: any) => err),
  );
};
